/**
 * As fichas de `config.default` que só existem na hora de criar — a mesma regra
 * do servidor (`structure/domain/default-token.ts`), aqui só para pré-preencher:
 * quem grava de verdade é a escrita. `undefined` = sem valor (`$me` sem sessão, ou
 * uma EDIÇÃO: a linha já nasceu, e "hoje" não reescreve um vazio gravado).
 */
export function resolveDefault(
	value: unknown,
	at: {
		readonly now: Date;
		readonly timeZone: string;
		readonly me?: string;
		readonly editing?: boolean;
	},
): unknown {
	if (at.editing && typeof value === "string" && ["$today", "$now", "$me"].includes(value))
		return undefined;
	if (value === "$today") return at.now.toLocaleDateString("en-CA", { timeZone: at.timeZone });
	if (value === "$now") return at.now.toISOString();
	if (value === "$me") return at.me || undefined;
	return value;
}
